import { useTranslation } from "react-i18next";
import img from "../../assets/img/illu/eveil.webp";

export default function Learning() {
  const { t } = useTranslation();

  return (
    <section className="Learning fade" id="learning">
      <div className="learning-content">
        <article>
          <h2>{t("learning.title")}</h2>
          <p className="learning-subtitle">{t("learning.subtitle")}</p>
          <p>{t("learning.p1")}</p>
          <p>{t("learning.p2")}</p>
          <p>{t("learning.p3")}</p>
          <p>{t("learning.p4")}</p>
        </article>
        <div className="learning-img">
          <img src={img} alt="Enfants en activité" />
        </div>
      </div>
      <div className="learning-line"></div>
    </section>
  );
}
